const OUTLINE = '#2b4a6f';
const LENS_TOP = '#cfe8fb';
const LENS_BOTTOM = '#8fc4ef';
const SHINE = '#ffffff';
const LENS_GRADIENT_ID = 'safety-goggles-lens-gradient';

// One wide, rounded wrap-around lens with an arch over the nose.
const LENS_OUTLINE =
  'M7 12.5 Q7 8 11.5 8 H52.5 Q57 8 57 12.5 V21.5 Q57 27.5 51 27.5 H39.5 Q36.6 27.5 35.3 24.6 Q32 19.2 28.7 24.6 Q27.4 27.5 24.5 27.5 H13 Q7 27.5 7 21.5 Z';

/**
 * Wrap-around lab safety goggles: a light blue see-through lens with a navy rim, small
 * side tabs where the strap attaches, and a glint of light. An SVG, so it looks the
 * same on every phone and computer.
 */
export default function SafetyGogglesIcon({ width = 88, height = 64, className }) {
  return (
    <svg className={className} width={width} height={height} viewBox="0 3 64 30" role="img" aria-label="Lab safety goggles">
      <defs>
        <linearGradient id={LENS_GRADIENT_ID} x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={LENS_TOP} />
          <stop offset="100%" stopColor={LENS_BOTTOM} />
        </linearGradient>
      </defs>

      {/* side tabs where the strap clips on */}
      <rect x="2.5" y="12" width="6" height="8" rx="2" fill={OUTLINE} />
      <rect x="55.5" y="12" width="6" height="8" rx="2" fill={OUTLINE} />

      {/* lens with a thick rim */}
      <path d={LENS_OUTLINE} fill={`url(#${LENS_GRADIENT_ID})`} stroke={OUTLINE} strokeWidth="2.6" strokeLinejoin="round" />

      {/* glint of light on the glass */}
      <path d="M44 23.5 L50.5 11.5" stroke={SHINE} strokeWidth="2.2" strokeLinecap="round" opacity="0.9" />
      <path d="M48.5 23 L52.8 15" stroke={SHINE} strokeWidth="1.2" strokeLinecap="round" opacity="0.8" />
    </svg>
  );
}
